import { render, staticRenderFns } from "./modalAgregarnewsletter.vue?vue&type=template&id=570a745d&"
import script from "./modalAgregarnewsletter.vue?vue&type=script&lang=js&"
export * from "./modalAgregarnewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports